<script setup lang="ts">
import { useRoute } from "vue-router";

const route = useRoute();
</script>

<template>
  <section class="notfound">
    <h1>404</h1>
    <p>
      Route <code>{{ route.fullPath }}</code> does not exist.
    </p>
    <RouterLink to="/">Back to dashboard</RouterLink>
  </section>
</template>

<style scoped>
.notfound {
  max-width: 40rem;
}
</style>
